// extracted by mini-css-extract-plugin
export var errorIcon = "_k8-1";
export var nameLogo = "_k8-0";